(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/winner-ticker/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/widgets/winner-ticker/assets/javascripts/utils.js');
"use strict";


const trinidad = svs.isServer ? require('@svenskaspelab/trinidad-core').core : null;
let constants;
let urlMapping;
if (svs.isServer) {
  constants = require('./constants.es6');
  urlMapping = trinidad.urlMapping;
} else {
  constants = svs.widget.winner_ticker.constants;
  urlMapping = svs.core.urlMapping;
}
const {
  TickerBrand,
  TickerFeed
} = constants;
const getBrand = winnerSetup => {
  switch (winnerSetup) {
    case 'bingo':
      return TickerBrand.BINGO;
    case 'momangSlots':
    case 'momangLiveSlots':
      return TickerBrand.MOMANG;
    case 'casinoSlots':
    case 'casinoLiveSlots':
    default:
      return TickerBrand.CASINO;
  }
};
const getFeed = winnerSetup => {
  switch (winnerSetup) {
    case 'bingo':
      return TickerFeed.BINGO;
    case 'casinoLiveSlots':
    case 'momangLiveSlots':
      return TickerFeed.LIVE_CASINO;
    case 'casinoSlots':
    case 'momangSlots':
    default:
      return TickerFeed.SLOTS;
  }
};
const normalizeBingoWinners = (winners, gameRooms) => winners.map(winner => {
  const gameRoom = gameRooms.find(room => room.name === winner.game.name);
  const imageSrc = constants.BingoImgSrc[gameRoom.id];
  return {
    gameName: winner.game.name,
    amount: winner.amount,
    href: gameRoom ? "".concat(urlMapping.get('bingoHome'), "/spela/").concat(gameRoom.id, "?gameName=").concat(gameRoom.name) : null,
    id: winner.timeStamp,
    imageSrc
  };
});
const normalizeBingoWinnersOld = (winners, gameRooms) => winners.map(winner => {
  const gameRoom = gameRooms.find(room => room.name === winner.game.name);
  const imageSrc = constants.BingoImgSrc[gameRoom.id];
  return {
    gameName: winner.game.name,
    amount: winner.amountSek,
    href: gameRoom ? "".concat(urlMapping.get('bingoHome'), "/spela/").concat(gameRoom.id, "?gameName=").concat(gameRoom.name) : null,
    id: winner.timeStamp,
    imageSrc
  };
});
const localCasinoCache = {};
const normalizeCasinoWinners = (winners, returnUrl) => {
  var _trinidad$components$, _svs$components$casin;
  const casinoGamesObj = svs.isServer ? (_trinidad$components$ = trinidad.components.require('casino', 'game-cache').getGameCache()) === null || _trinidad$components$ === void 0 ? void 0 : _trinidad$components$.games : (_svs$components$casin = svs.components.casino) === null || _svs$components$casin === void 0 || (_svs$components$casin = _svs$components$casin.data) === null || _svs$components$casin === void 0 || (_svs$components$casin = _svs$components$casin.gameCache) === null || _svs$components$casin === void 0 ? void 0 : _svs$components$casin.index;
  const gamesList = Object.values(casinoGamesObj !== null && casinoGamesObj !== void 0 ? casinoGamesObj : {});
  return winners.map(winner => {
    const fallbackGame = {
      title: winner.game.name,
      name: null,
      opsGameId: String(winner.game.level3)
    };
    let cachedGame = localCasinoCache[String(winner.game.level3)];
    if (!cachedGame) {
      var _gamesList$find;
      const gameData = (_gamesList$find = gamesList.find(game => game.opsGameId === String(winner.game.level3))) !== null && _gamesList$find !== void 0 ? _gamesList$find : fallbackGame; 

      const casinoTickerGame = {
        name: gameData.name,
        title: gameData.title,
        opsGameId: gameData.opsGameId,
        image: gameData.lobbyImage
      };
      localCasinoCache[String(winner.game.level3)] = casinoTickerGame;
      cachedGame = casinoTickerGame;
    }
    let href;

    if (cachedGame.name) {
      href = "".concat(urlMapping.get('casinoGameInfo'), "/").concat(cachedGame.name);
      if (returnUrl) {
        href += "?returnUrl=".concat(encodeURIComponent(returnUrl));
      }
    }
    return {
      gameName: cachedGame.title,
      amount: winner.amount / 100,
      href,
      id: winner.timeStamp,
      image: cachedGame.image
    };
  });
};
const normalizeCasinoWinnersOld = (winners, returnUrl) => {
  var _trinidad$components$2, _svs$components$casin2;
  const casinoGamesObj = svs.isServer ? (_trinidad$components$2 = trinidad.components.require('casino', 'game-cache').getGameCache()) === null || _trinidad$components$2 === void 0 ? void 0 : _trinidad$components$2.games : (_svs$components$casin2 = svs.components.casino) === null || _svs$components$casin2 === void 0 || (_svs$components$casin2 = _svs$components$casin2.data) === null || _svs$components$casin2 === void 0 || (_svs$components$casin2 = _svs$components$casin2.gameCache) === null || _svs$components$casin2 === void 0 ? void 0 : _svs$components$casin2.index;
  const gamesList = Object.values(casinoGamesObj !== null && casinoGamesObj !== void 0 ? casinoGamesObj : {});
  return winners.map(winner => {
    const fallbackGame = {
      title: winner.game.name,
      name: null,
      opsGameId: winner.game.level3
    };
    let cachedGame = localCasinoCache[winner.game.level3];
    if (!cachedGame) {
      var _gamesList$find2;
      const gameData = (_gamesList$find2 = gamesList.find(game => game.opsGameId === winner.game.level3)) !== null && _gamesList$find2 !== void 0 ? _gamesList$find2 : fallbackGame;
      const casinoTickerGame = {
        name: gameData.name,
        title: gameData.title,
        opsGameId: gameData.opsGameId,
        image: gameData.lobbyImage
      };
      localCasinoCache[winner.game.level3] = casinoTickerGame;
      cachedGame = casinoTickerGame;
    }
    let href;

    if (cachedGame.name) {
      href = "".concat(urlMapping.get('casinoGameInfo'), "/").concat(cachedGame.name);
      if (returnUrl) {
        href += "?returnUrl=".concat(encodeURIComponent(returnUrl));
      }
    }
    return {
      gameName: cachedGame.title,
      amount: winner.amountSek,
      href,
      id: winner.timeStamp,
      image: cachedGame.image
    };
  });
};
const addTrackingListener = (el, brand, winnerItem) => {
  el.addEventListener('click', () => {
    svs.components.analytics.trackEvent({
      action: 'game ticker',
      category: 'Navigation',
      opt_label: "".concat(brand).concat(brand === TickerBrand.BINGO ? ",".concat(winnerItem.gameName) : ''),
      opt_value: winnerItem.amount / 100
    });
  });
  return el;
};
const addTrackingListenerOld = (el, brand, winnerItem) => {
  el.addEventListener('click', () => {
    svs.components.analytics.trackEvent({
      action: 'game ticker',
      category: 'Navigation',
      opt_label: "".concat(brand).concat(brand === TickerBrand.BINGO ? ",".concat(winnerItem.gameName) : ''),
      opt_value: winnerItem.amountSek
    });
  });
  return el;
};
const utils = {
  getBrand,
  getFeed,
  normalizeBingoWinners,
  normalizeCasinoWinners,
  normalizeBingoWinnersOld,
  normalizeCasinoWinnersOld,
  addTrackingListener,
  addTrackingListenerOld
};
if (svs.isServer) {
  module.exports = utils;
} else {
  svs.widget.winner_ticker.utils = utils;
}

 })(window);